import { createStore, combineReducers, applyMiddleware } from "redux";
import userMenu from "./reducers/userMenu";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas";
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
export function createReduxStore(name) {
  const reducers = combineReducers({
    userMenu
  });
  const composeEnhancers = composeWithDevTools({ name });
  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware));
  let store = createStore(reducers, middleware);
  sagaMiddleware.run(rootSaga);
  return store;
}
